import { Data_getInstance319j5in8e6yr5 as Data_getInstance } from './adapter/GrantDiscordAccessMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { GrantDiscordAccessMutationSelections_getInstance2vbuomracm2oq as GrantDiscordAccessMutationSelections_getInstance } from './selections/GrantDiscordAccessMutationSelections.mjs';
import { GrantDiscordAccessMutation_VariablesAdapter_instance37ervv779xwn4 as GrantDiscordAccessMutation_VariablesAdapter_instance } from './adapter/GrantDiscordAccessMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(grantDiscordAccess) {
        this.n6r_1 = grantDiscordAccess;
      }
      toString() {
        return 'Data(grantDiscordAccess=' + this.n6r_1 + ')';
      }
      hashCode() {
        return this.n6r_1 == null ? 0 : getBooleanHashCode(this.n6r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.n6r_1 == other.n6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.o6r_1 = obj(Data_getInstance());
        this.p6r_1 = (new (Builder())('data', Companion_getInstance().r6p_1)).q47(GrantDiscordAccessMutationSelections_getInstance().s6r_1).l38();
        this.q6r_1 = 'a0a2ff4fbaeeebae9d26579701f15dc651303e3d602f36a89a72adc301d4b383';
        this.r6r_1 = 'grantDiscordAccess';
      }
      u6p() {
        return 'mutation grantDiscordAccess($input: GrantDiscordAccessInput!) { grantDiscordAccess(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var GrantDiscordAccessMutationClass;
function GrantDiscordAccessMutation() {
  if (GrantDiscordAccessMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.t6r_1 = input;
      }
      w6p() {
        return 'a0a2ff4fbaeeebae9d26579701f15dc651303e3d602f36a89a72adc301d4b383';
      }
      operationId() {
        return this.w6p();
      }
      i4b() {
        return Companion_getInstance_0().u6p();
      }
      x6p() {
        return 'grantDiscordAccess';
      }
      operationName() {
        return this.x6p();
      }
      n4a(writer, customScalarAdapters, withDefaultValues) {
        GrantDiscordAccessMutation_VariablesAdapter_instance.u6r(writer, this, customScalarAdapters, withDefaultValues);
      }
      m4a() {
        return Companion_getInstance_0().o6r_1;
      }
      toString() {
        return 'GrantDiscordAccessMutation(input=' + this.t6r_1.toString() + ')';
      }
      hashCode() {
        return this.t6r_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessMutation()))
          return false;
        if (!this.t6r_1.equals(other.t6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessMutation', VOID, VOID, [Mutation()]);
    GrantDiscordAccessMutationClass = $;
  }
  return GrantDiscordAccessMutationClass;
}
//region block: exports
export {
  Data as Data3pzhqfxhg1ap1,
  GrantDiscordAccessMutation as GrantDiscordAccessMutation1e5ff0b653k4l,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessMutation.mjs.map
